// src/features/home/components/RecommendedVideoListWide.js
import React, { useMemo, useState } from "react";
import "../../../shared/styles/RecommendedVideoList.css";
import { bumpVideoView } from "../../../shared/utils/bumpVideoView";

import { BsYoutube, BsLightningCharge } from "react-icons/bs";
import { FaPodcast } from "react-icons/fa";

function getYouTubeId(url = "") {
  try {
    const u = new URL(url);
    if (u.searchParams.get("v")) return u.searchParams.get("v");
    if (u.hostname.includes("youtu.be")) return u.pathname.replace("/", "") || null;
    if (u.pathname.startsWith("/embed/")) return u.pathname.split("/embed/")[1]?.split("?")[0] || null;
    if (u.pathname.includes("/shorts/")) {
      return u.pathname.split("/shorts/")[1]?.split("?")[0] || null;
    }
    return null;
  } catch {
    return null;
  }
}

function ytEmbedUrl(videoId) {
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
}

export default function RecommendedVideoListWide({ videos = [] }) {
  const [playingId, setPlayingId] = useState(null);
  const rows = useMemo(() => videos, [videos]);

  return (
    <div className="recommended-wide-grid">
      {rows.map((v) => {
        const href = v.url || v.fileUrl || "";
        const isYouTubeLike =
          v.kind === "youtube" ||
          v.kind === "appetizer" ||
          v.kind === "oral_exam_tips" ||
          v.kind === "podcast" ||
          v.kind === "shorts" ||
          v.kind === "shorts_prepare_for_exams";
        const isShorts =
          v.kind === "shorts" ||
          v.kind === "shorts_prepare_for_exams";
        const videoId = isYouTubeLike ? getYouTubeId(href) : null;
        const isPlaying = playingId === v.id;

        const primaryCat = v.categories?.[0] || "";
        const meta = [
          primaryCat,
          typeof v.viewCounts === "number" ? `${v.viewCounts} views` : "",
        ]
          .filter(Boolean)
          .join(" • ");

        return (
          <div key={v.id} className="recommended-wide-item">
            {/* LEFT: player */}
            <div className="recommended-wide-media">
              <div className="ratio ratio-16x9 bg-dark position-relative rounded overflow-hidden">
                {isYouTubeLike && videoId && isPlaying ? (
                  <iframe
                    src={ytEmbedUrl(videoId)}
                    title={v.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ border: 0 }}
                  />
                ) : (
                  <>
                    <img
                      src={
                        v.thumbUrl ||
                        (videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : "")
                      }
                      alt={v.title}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />

                    {/* ✅ ปุ่มเล่น: youtube + podcast */}
                    {isYouTubeLike && videoId ? (
                      <button
                        type="button"
                        className={`video-play-btn ${
                          v.kind === "podcast"
                            ? "video-play-btn--podcast"
                            : isShorts
                            ? "video-play-btn--shorts"
                            : "video-play-btn--youtube"
                        }`}
                        aria-label="เล่นวิดีโอ"
                        onClick={async () => {
                          setPlayingId(v.id);
                          try {
                            await bumpVideoView(v.id);
                          } catch {}
                        }}
                      >
                        {v.kind === "podcast" ? (
                          <FaPodcast size={42} className="video-play-icon" />
                        ) : isShorts ? (
                          <BsLightningCharge size={42} className="video-play-icon" />
                        ) : (
                          <BsYoutube size={42} className="video-play-icon" />
                        )}
                      </button>
                    ) : (
                      // facebook/vertical/อื่นๆ: เปิดลิงก์ใหม่
                      <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="stretched-link"
                        aria-label="เปิดวิดีโอ"
                      />
                    )}
                  </>
                )}
              </div>
            </div>

            {/* RIGHT: text */}
            <div className="recommended-wide-text">
              <div className="recommended-wide-title">{v.title}</div>

              {v.description ? (
                <div className="recommended-wide-desc">{v.description}</div>
              ) : null}

              <div className="recommended-wide-meta">{meta}</div>

              {isYouTubeLike && href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="recommended-wide-link"
                >
                  เปิดใน {v.kind === "podcast" ? "Podcast" : "YouTube"} ›
                </a>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}